export default __webpack_public_path__ + "static/media/keune.d3326dc1.JPG";